import type { TransitionPhase } from '@toolproof-core/visualization/derivation/_contract/derivation';

import type { OverviewRuntimeState } from '@/workflow/_contract/runtime';

export const ACTION_OVERVIEW = 'camera-overview';
export const ACTION_FREE = 'camera-free';

export function requestWorkflowOverview<T extends OverviewRuntimeState>(state: T): T {
    const request = (state.overviewNavigationSequence ?? 0) + 1;
    return { ...state, pendingOverviewNavigation: request, overviewNavigationSequence: request };
}

export function deriveOverviewTransition(state: OverviewRuntimeState, durationMs = 700): TransitionPhase[] | undefined {
    if (state.pendingOverviewNavigation == null) return undefined;
    return [{
        patch: {},
        cameraNavigation: { view: 'overview' },
        transitionOptions: {
            transitionKind: 'interpolated',
            transitionKey: `workflow-overview:${state.pendingOverviewNavigation}`,
            duration: durationMs,
            easing: 'smoothstep',
        },
    }];
}
